export default {"src":"/_next/static/media/endive.66cd99c5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};